export const styles = {
  // Layout
  container:
    "min-h-screen flex items-center justify-center bg-gray-50 px-4 py-8",
  wrapper: "w-full max-w-md",

  // Logo section
  logoSection: "text-center mb-8",
  logo: "text-h2 font-bold text-primary-600",
  title: "text-h3 text-text-950 mt-4",
  subtitle: "text-body text-text-700 mt-2",

  // Card
  card: "bg-white rounded-2xl shadow-lg p-8",

  // Error
  errorBox: "mb-6 p-4 bg-error-light rounded-lg",
  errorText: "text-body-sm text-error",

  // Success state
  successContainer: "text-center py-6",
  successIcon:
    "w-16 h-16 bg-success-light rounded-full flex items-center justify-center mx-auto mb-4",
  successTitle: "text-h4 text-text-950 mb-2",
  successText: "text-body text-text-700 mb-3",
  successEmail: "font-medium text-text-950",
  successHint: "text-body-sm text-text-500 mb-6",
  changeEmailButton: "text-body-sm text-primary-600 hover:underline",

  // Google button
  googleButton:
    "w-full flex items-center justify-center gap-3 px-4 py-3 bg-white border border-gray-200 rounded-xl font-medium text-text-950 hover:bg-gray-50 hover:border-gray-300 hover:-translate-y-0.5 hover:shadow-md active:translate-y-0 transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 disabled:hover:shadow-none",

  // Divider
  divider: "flex items-center gap-4 my-6",
  dividerLine: "flex-1 h-px bg-gray-200",
  dividerText: "text-body-sm text-text-600",

  // Form
  label: "block text-body-sm font-medium text-text-950 mb-2",
  submitButton:
    "btn-primary w-full justify-center disabled:opacity-50 disabled:cursor-not-allowed",

  // Form grid (for profile step)
  formGrid: "grid grid-cols-2 gap-4",

  // Back button
  backButton:
    "flex items-center gap-2 text-body-sm text-text-600 hover:text-primary-600 mb-6 transition-colors",

  // Step indicator
  stepIndicator: "flex items-center justify-center gap-2 mb-6",
  stepDot: "w-2 h-2 rounded-full bg-gray-300",
  stepDotActive: "w-2 h-2 rounded-full bg-primary-500",

  // Terms
  terms: "text-center text-caption text-text-600 mt-4",
  termsLink: "text-primary-600 hover:underline",

  // Footer
  footer: "text-center text-body-sm text-text-600 mt-6",
  footerLink: "text-primary-600 font-medium hover:underline",
  backLink: "text-center mt-6",
  backLinkText: "text-body-sm text-text-600 hover:text-primary-600",
} as const
